<template>
  <b-modal
    :id="'modal-trip-' + data?._id"
    no-close-on-backdrop
    :dialog-class="`modal-trip_wrapper ${isLangRtl ? 'modal-trip_wrapper-rtl' : ''}`"
  >
    <div>
      <b-alert :show="error && error.length ? true : false" variant="danger">
        <div v-if="Array.isArray(error)">
          <div class="d-flex flex-column my-1" v-for="(error_text, index) in error" :key="index">
            {{ error_text }}
          </div>
        </div>
        <div v-else>
          <div v-html="error || '&nbsp;'"></div>
        </div>
      </b-alert>
      <div>
        <validation-observer ref="observer" v-if="!data?.isDeadhead">
          <edit-trip
            :payload="payload"
            :loading="loading"
            :validFromDate="validFromDate"
            :validToDate="validToDate"
            :validFromTime="validFromTime"
            :validToTime="validToTime"
            :tripID="data?._id"
            :status="data.status"
            :disabledBranch="disabledBranch"
            :isDateEditDisabled="isDateEditDisabled"
          />
        </validation-observer>
      </div>
      <div class="action-container d-flex align-items-center justify-content-end">
        <div style="margin-inline-end: 1rem">
          <base-button
            id="edit-trip-form-cancel-btn"
            variant="secondary"
            :disabled="loading"
            @click="cancel"
          >
            {{ $t('cancel') }}
          </base-button>
        </div>
        <div>
          <base-button
            id="edit-trip-form-submit-btn"
            variant="primary"
            :loading="loading"
            :disabled="payload.error_location"
            @click="save"
          >
            {{ $t('save') }}
          </base-button>
        </div>
      </div>
      <base-alert
        modalId="edit-trip-success-modal"
        icon="popup-success-icon"
        :title="$t('journey-updated')"
        :description="$t('journey-information-has-been-updated')"
      >
        <template #buttons>
          <base-button
            id="edit-trip-success-modal-reservation-btn"
            variant="primary"
            @click="submit"
            class="col-3 mb-3"
          >
            {{ $t('trip-details') }}
          </base-button>
        </template>
      </base-alert>

      <base-alert
        modalId="edit-trip-warning-modal"
        icon="popup-warning-icon"
        :title="$t('journey-updated-warning')"
        :description="$t('journey-updated-warning-msg')"
      >
        <template #buttons>
          <base-button
            id="edit-trip-warning-modal-cancel-btn"
            variant="secondary"
            @click="hideModal"
            class="col-3 mb-3"
          >
            {{ $t('no') }}
          </base-button>
          <base-button
            id="edit-trip-warning-modal-submit-btn"
            variant="primary"
            @click="moveTo"
            class="col-3 mb-3"
          >
            {{ $t('yes') }}
          </base-button>
        </template>
      </base-alert>
    </div>
  </b-modal>
</template>
<script>
import moment from 'moment'
import EditTrip from './EditTrip.vue'
import TripService from '@/services/trip.service'

export default {
  props: ['data'],
  components: {
    EditTrip,
  },
  data() {
    return {
      loading: false,
      error: null,
      payload: {
        id: null,
        reservation: null,
        start: null,
        end: null,
        from_date: null,
        to_date: null,
        from_time: null,
        to_time: null,
        error_location: false,
        branch: null,
        contract: null,
        waterSource: null,
        garage: null,
        zone: null,
      },
    }
  },
  methods: {
    hideModal() {
      this.$bvModal.hide('edit-trip-warning-modal')
    },
    moveTo() {
      this.$bvModal.hide('edit-trip-warning-modal')
      this.$bvModal.hide('modal-trip-' + this.id)
      this.refreshData()
      this.$emit('refetchData')
    },
    cancel() {
      this.$bvModal.show('edit-trip-warning-modal')
    },
    async save() {
      const valid = await this.$refs.observer.validate()
      if (
        !valid ||
        !this.validFromDate ||
        !this.validToDate ||
        !this.validFromTime ||
        !this.validToTime
      )
        return
      if (this.payload.error_location) return

      this.loading = true
      this.error = null

      // Constructing the final object for the API
      const apiPayload = {
        scheduledStartDate: moment(this.payload.from_date).locale('en').format('YYYY-MM-DD'),
        scheduledEndDate: moment(this.payload.to_date).locale('en').format('YYYY-MM-DD'),
        scheduledStartTime: this.payload.from_time,
        scheduledEndTime: this.payload.to_time,
        branch: this.payload.branch,
        garage: this.payload.garage,
        zone: this.payload.zone,
        waterSource: this.payload.waterSource,
        id: this.data?._id,
      }

      if (this.payload.start) apiPayload['startLocation'] = this.payload.start
      if (this.payload.end) apiPayload['endLocation'] = this.payload.end

      TripService.put(apiPayload, 'update-by-operator')
        .then((res) => {
          this.$bvModal.show('edit-trip-success-modal')
        })
        .catch(({ message }) => {
          this.error = message
        })
        .finally(() => {
          this.loading = false
        })
    },
    refreshData() {
      this.$emit('refreshData')
    },
    submit() {
      this.$bvModal.hide('edit-trip-success-modal')
      this.$bvModal.hide('modal-trip-' + this.data?._id)
      this.refreshData()
    },
  },
  computed: {
    validFromDate() {
      if (this.payload?.reservation?.type === 'Recurrence' && this.payload.from_date) {
        return true
      }

      let valid
      if (this.payload.from_date) {
        const a = moment(this.payload.from_date).set('hour', 0).set('minute', 0).set('seconds', 0)
        const b = moment().set('hour', 0).set('minute', 0).set('seconds', 0)
        const day = a.diff(b, 'days')
        valid = day >= 0
      } else valid = true

      return valid
    },
    validToDate() {
      if (this.payload?.reservation?.type === 'Recurrence' && this.payload.to_date) {
        return true
      }

      let valid
      if (this.payload.from_date && this.payload.to_date) {
        let a = moment(this.payload.from_date).set('hour', 0).set('minute', 0).set('seconds', 0)
        let b = moment(this.payload.to_date).set('hour', 0).set('minute', 0).set('seconds', 0)

        if (this.payload.from_time) {
          const from_time_parts = this.payload.from_time.split(':')
          a = moment(this.payload.from_date ? this.payload.from_date : new Date())
            .set('hour', from_time_parts[0])
            .set('minute', from_time_parts[1])
            .set('seconds', 0)
        }
        if (this.payload.to_time) {
          const to_time_parts = this.payload.to_time.split(':')

          b = moment(this.payload.to_date ? this.payload.to_date : new Date())
            .set('hour', to_time_parts[0])
            .set('minute', to_time_parts[1])
            .set('seconds', 0)
        }

        const minutes = b.diff(a, 'minutes')
        valid = minutes >= 0 && minutes <= 2880
      } else valid = true
      return valid
    },
    validFromTime() {
      if (
        this.payload?.reservation?.type === 'Recurrence' &&
        this.payload.from_time &&
        this.payload.from_date
      ) {
        const date1 = moment(this.payload.from_date).startOf('day')
        const todays_date = moment().startOf('day')
        const diff = date1.diff(todays_date, 'days')
        if (diff === 0) {
          let todays_date = moment(new Date())
          let from_time = moment(this.payload.from_time, 'HH:mm:ss')
          let diff1 = from_time.diff(todays_date, 'minutes')
          return diff1 >= 0
        }
      }

      let valid,
        a,
        b = moment()
      if (this.payload.from_time) {
        const from_time_parts = this.payload.from_time.split(':')

        a = moment(this.payload.from_date ? this.payload.from_date : new Date())
          .set('hour', from_time_parts[0])
          .set('minute', from_time_parts[1])
          .set('seconds', 0)
      }

      if (a && b) {
        const minutes = a.diff(b, 'minutes')
        valid = minutes > 0
      } else valid = true
      return valid
    },
    validToTime() {
      if (
        this.payload?.reservation?.type === 'Recurrence' &&
        this.payload.from_time &&
        this.payload.to_time
      ) {
        let from_time, to_time

        if (this.payload.from_time) {
          from_time = moment(this.payload.from_time, 'HH:mm:ss')
        }

        if (this.payload.to_time) {
          to_time = moment(this.payload.to_time, 'HH:mm:ss')
        }

        let diff1 = to_time.diff(from_time, 'minutes')
        return diff1 > 0
      }

      let valid, a, b
      if (this.payload.from_time) {
        const from_time_parts = this.payload.from_time.split(':')

        a = moment(this.payload.from_date ? this.payload.from_date : new Date())
          .set('hour', from_time_parts[0])
          .set('minute', from_time_parts[1])
          .set('seconds', 0)
      }
      if (this.payload.to_time) {
        const to_time_parts = this.payload.to_time.split(':')

        b = moment(this.payload.to_date ? this.payload.to_date : new Date())
          .set('hour', to_time_parts[0])
          .set('minute', to_time_parts[1])
          .set('seconds', 0)
      }

      if (a && b) {
        const minutes = b.diff(a, 'minutes')
        valid = minutes >= 1 && minutes <= 2880
      } else valid = true
      return valid
    },
    disabledBranch() {
      return !!(this.data?.mainDriver || this.data?.secondaryDriver || this.data?.vehicle)
    },
    isDateEditDisabled() {
      // Only can update trip with statuses [Booking-Confirmed, Booking-Re-Assigned, Booking-Un-Assigned, Booking-Pending]
      const allowedStatuses = [
        'Booking-Confirmed',
        'Booking-Re-Assigned',
        'Booking-Un-Assigned',
        'Booking-Pending',
      ]
      return !allowedStatuses.includes(this.data?.status)
    },
  },
  i18n: {
    messages: {
      en: require('@/services/i18n/locales/en/reservationOperations.json'),
      ar: require('@/services/i18n/locales/ar/reservationOperations.json'),
    },
  },
  watch: {
    'payload.waterSource': {
      deep: true,
      handler(val) {
        if (val) {
          const getLocation = this.$store.getters['enums/garage_enums'].find(
            (garage) => garage.value === val
          )
          if (getLocation && getLocation.garageLocation && getLocation.garageLocation.name) {
            this.payload.start = {
              location: getLocation.garageLocation.location,
              name: getLocation.garageLocation.name,
            }
          }
        }
      },
    },
  },
  mounted() {
    if (this.data?._id) {
      console.log('[SFMS-1516][edit/index.vue mounted] raw trip data for start/waterSource:', {
        tripId: this.data?._id,
        startLocation: this.data?.startLocation,
        waterSource: this.data?.waterSource,
        branch: this.data?.branch,
      })

      this.payload = {
        id: this.data?._id,
        reservation: this.data?.reservation,
        start: this.data?.startLocation,
        end: this.data?.endLocation,
        from_date: new Date(this.data?.scheduledStartDate),
        to_date: new Date(this.data?.scheduledEndDate),
        from_time: this.data?.scheduledStartTime
          ? moment.utc(this.data.scheduledStartTime).locale('en').local().format('HH:mm:ss')
          : null,
        to_time: this.data?.scheduledEndTime
          ? moment.utc(this.data.scheduledEndTime).locale('en').local().format('HH:mm:ss')
          : null,
        branch: this.data?.branch?._id,
        error_location: false,
        contract: this.data?.contract,
        waterSource: this.data?.waterSource
          ? String(this.data.waterSource?._id || this.data.waterSource)
          : null,
        blanketOrder: this.data?.reservation?.blanketOrder || null,
        garage: this.data?.garage?._id ? String(this.data.garage._id) : null,
        // In Parent Component mounted()
        zone: this.data?.zone?._id
          ? String(this.data.zone._id)
          : this.data?.zone
          ? String(this.data.zone)
          : null,
      }

      console.log('[SFMS-1516][edit/index.vue mounted] constructed payload.start/waterSource:', {
        tripId: this.data?._id,
        payloadStart: this.payload.start,
        payloadWaterSource: this.payload.waterSource,
        payloadBranch: this.payload.branch,
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.action-container {
  background: var(--color-01);
  border-top: 1px solid var(--color-23);
  padding: 30px;
  padding-bottom: 0;
  width: 100%;
  z-index: 1000;
}
</style>

<style lang="scss">
.modal-trip_wrapper {
  position: absolute !important;
  inset-inline-start: 42%;
  transform: translateX(-50%) !important;

  .modal-content {
    width: 800px !important;
    margin-bottom: 1rem;
  }

  .modal-body {
    padding: 1.5rem !important;
  }
}

.modal-trip_wrapper-rtl {
  transform: translateX(50%) !important;
}
</style>
